"use strict";require('@ebay/skin/icon');
require('@ebay/skin/carousel');